module.exports = __webpack_public_path__ + "static/media/picto-link.861d4fff.svg";